// Date formatting utility to handle timezone issues
export const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return 'No date';

    try {
        // Handle different date formats
        let date: Date;

        // Check if it's already a proper ISO string with timezone
        if (dateString.includes('Z') || dateString.includes('+') || dateString.includes('-', 10)) {
            // Already has timezone info
            date = new Date(dateString);
        } else {
            // Treat as local timezone (not UTC)
            date = new Date(dateString);
        }

        // Check if date is valid
        if (isNaN(date.getTime())) {
            return 'Invalid date';
        }

        // Format date in Indian timezone without timezone conversion
        return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    } catch (error) {
        console.error('Date formatting error:', error);
        return 'Invalid date';
    }
};

// Format date with time
export const formatDateTime = (dateString: string | null | undefined): string => {
    if (!dateString) return 'No date';

    try {
        let date: Date;

        // Check if it's already a proper ISO string with timezone
        if (dateString.includes('Z') || dateString.includes('+') || dateString.includes('-', 10)) {
            date = new Date(dateString);
        } else {
            // Treat as local timezone (not UTC)
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            return 'Invalid date';
        }

        return date.toLocaleString('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    } catch (error) {
        console.error('DateTime formatting error:', error);
        return 'Invalid date';
    }
};

// Format date for display in tables
export const formatTableDate = (dateString: string | null | undefined): string => {
    if (!dateString) return '-';

    try {
        let date: Date;

        // Check if it's already a proper ISO string with timezone
        if (dateString.includes('Z') || dateString.includes('+') || dateString.includes('-', 10)) {
            date = new Date(dateString);
        } else {
            // Treat as local timezone (not UTC)
            date = new Date(dateString);
        }

        if (isNaN(date.getTime())) {
            return '-';
        }

        return date.toLocaleDateString('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        });
    } catch (error) {
        console.error('Table date formatting error:', error);
        return '-';
    }
};
